import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import defaultStyles from "./styles.pcss";
import Emoji from "../Emoji";
function getHardPosition(width, position) {
  var bias = width / -2;
  if (position === 'right') {
    bias -= width / 2 - 16;
  } else if (position === 'left') {
    bias += width / 2 - 16;
  }
  return bias;
}
export function customTooltipFactory(customStyles) {
  var cx = classNames.bind(customStyles);
  var Tooltip = /*#__PURE__*/function (_React$Component) {
    _inherits(Tooltip, _React$Component);
    var _super = _createSuper(Tooltip);
    function Tooltip(props) {
      var _this;
      _classCallCheck(this, Tooltip);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "calculatePosition", function () {
        var _this$props = _this.props,
          onShow = _this$props.onShow,
          position = _this$props.position;
        if (onShow) onShow();
        if (position) return;
        var elem = _this.textElem;
        var _elem$getBoundingClie = elem.getBoundingClientRect(),
          left = _elem$getBoundingClie.left,
          right = _elem$getBoundingClie.right;
        var bias = _this.state.bias;
        if (left < 0) {
          bias += (left - 12) * -1;
        } else if (right > window.innerWidth) {
          bias -= right - window.innerWidth + 12;
        }
        _this.setState({
          bias: bias
        });
      });
      _this.state = {
        bias: getHardPosition(props.width, props.position)
      };
      return _this;
    }
    _createClass(Tooltip, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        var bias = this.state.bias;
        var _this$props2 = this.props,
          width = _this$props2.width,
          icon = _this$props2.icon,
          className = _this$props2.className,
          contentPosition = _this$props2.contentPosition,
          text = _this$props2.text,
          label = _this$props2.label;
        var onTop = contentPosition === 'top';
        return /*#__PURE__*/React.createElement("span", {
          "aria-label": label,
          className: cx('component', icon && 'hasIcon', className),
          onClick: function onClick() {},
          onFocus: this.calculatePosition,
          onMouseEnter: this.calculatePosition,
          onTouchStart: this.calculatePosition,
          tabIndex: 0,
          "data-t-id": "components-Tooltip"
        }, icon ? /*#__PURE__*/React.createElement(Emoji, {
          className: cx('emoji'),
          name: icon
        }) : /*#__PURE__*/React.createElement("div", {
          "aria-hidden": true,
          className: cx('icon')
        }, "?"), /*#__PURE__*/React.createElement("div", {
          className: cx('arrow', {
            onTop: onTop
          })
        }), /*#__PURE__*/React.createElement("div", {
          className: cx('container', {
            onTop: onTop
          }),
          ref: function ref(e) {
            _this2.textElem = e;
          },
          style: {
            transform: "translateX(".concat(bias, "px)"),
            width: "".concat(width, "px")
          }
        }, text ? /*#__PURE__*/React.createElement("div", {
          className: cx('text'),
          dangerouslySetInnerHTML: {
            __html: text
          }
        }) : /*#__PURE__*/React.createElement("div", {
          className: cx('text')
        }, this.props.children)));
      }
    }]);
    return Tooltip;
  }(React.Component);
  _defineProperty(Tooltip, "defaultProps", {
    position: null,
    width: 300,
    label: 'Подробнее'
  });
  Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
    /** Позиция хвоста tooltip\'a относительно иконки */
    position: PropTypes.oneOf(['left', 'center', 'right']),
    /** Позиция текста tooltip\'a относительно иконки */
    contentPosition: PropTypes.oneOf(['top']),
    /** Параметр для добавления дополнительных классов */
    className: PropTypes.string,
    /** Любой компонент или строка */
    children: PropTypes.node,
    /** Размер компонента tooltip */
    width: PropTypes.number,
    /** Callback */
    onShow: PropTypes.func,
    /* Строка текста */
    text: PropTypes.string,
    /* Текст для aria-label */
    label: PropTypes.string,
    /** Icon/Emoji name */
    icon: PropTypes.string
  } : {};
  return Tooltip;
}
export default customTooltipFactory(defaultStyles);